<template lang="html">

  <div class="home wrapper">

    <div class="full-intro row-center">

      <slider-home></slider-home>
    </div>
<!--     <section class="banner-it container" v-if="lang == 'it'">
      <a href="https://ghrsummit.it/visitatori" target="_blank" rel="noopener noreferrer">
        <img src="/static/img/banner-congreso-it.gif" alt="">
      </a>
      <div class="container-btns">
        <a href="https://iformalia.es/blog/torna-alla-sua-7a-edizione-il-global-summit-human-resources-levento-nazionale-b2b-dedicato-al-mondo-delle-hr-e-del-people-management" target="_blank" rel="noopener noreferrer" class="btn-rounded-purple">BLOG DEL CONGRESSO</a>
        <a href=" https://iformalia.es/blog/intervista-a-sandro-marsiglia-country-manager-italy-di-iformalia" target="_blank" rel="noopener noreferrer" class="btn-rounded-purple">INTERVISTA</a>
      </div>
    </section> -->
    <productos-list></productos-list>

    <section class="downloads-apps container">
      <p>{{$t('home.descubrenos')}} </p>
      <a href="https://www.softwareadvice.com/lms/iformalia-profile/" target="_blank" rel="noopener noreferrer">
        <img src="/static/img/software-advice.png" alt="Software advise">
      </a>
      <a href="https://www.capterra.es/software/1061700/iformalia" target="_blank" rel="noopener noreferrer">
        <img src="/static/img/capterra.png" alt="Software advise">
      </a>
      <a href="https://www.getapp.cl/software/2071697/iformalia " target="_blank" rel="noopener noreferrer">
        <img src="/static/img/app-logo.png" alt="Software advise">
      </a>
    </section>
    <section class="quienes-somos-banner">

      <div class="contenedor-texto">

        <h2 class="title waypoints" data="fadeInUp" v-html="$t('home.title')"></h2>

        <div class="textos">

          <p class="waypoints" data="fadeInUp" v-html="$t('home.descriptionBold')"></p>
          <p class="waypoints" data="fadeInUp" v-html="$t('home.description')"></p>

        </div>

        <div class="contenedor-imagen row-end animate">

          <img src="/static/img/quienes-somos-imagen.jpg" alt="Quienes somos">

        </div>

      </div>

      <div class="contenedor-boton">

        <router-link :to="$t('enlaces.quienes_somos')" class="btn-rounded-blue waypoints" data="fadeInUp" v-html="$t('moreInfo')"></router-link>

      </div>

    </section>


  </div>

</template>

<script lang="js">
  import { mapGetters } from 'vuex';
  import ProductosList from '@/components/parts/productos-list';
  import sliderHome from '@/components/parts/slider-home';

  export default {
    name: 'home',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    components: {
      'productos-list': ProductosList,
      'slider-home': sliderHome
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    }
  }
</script>

<style scoped>
  .full-intro {
    height: auto;
    min-height: 75vh;
    width: 100%;
    background: #f3f7fb;
    margin-bottom: 40px;
  }

  .waypoints {
    -webkit-animation-delay: 1s;
    -o-animation-delay: 1s;
    animation-delay: 1s;
  }

  @media screen and (max-width: 600px) {
    .full-intro {
      min-height: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/home.vue